

































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import UCModal from '@shared/components/UCModal/UCModal.vue';
import useResponsive from '@shared/composables/useResponsive';

import SearchPreFiltersContent from './SearchPreFiltersContent.vue';
import { IFacetOptionsBySection, ISearchPreFiltersConfig, ISearchPreFiltersValue } from './types';

// Above the known third-party widgets (promo tab is z-index 90000, chat bubble, etc.).
const MOBILE_MODAL_Z_INDEX = '1000000';

// Relocates the bound element to <body> so a full-screen modal rendered inside the
// header is not trapped beneath body-level widgets by the header's stacking context,
// and sets the z-index inline (UCModal's own z-index can't be reached via scoped CSS).
const portalToBody = {
  inserted(el: HTMLElement) {
    el.style.zIndex = MOBILE_MODAL_Z_INDEX;
    document.body.appendChild(el);
  },
  unbind(el: HTMLElement) {
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  },
};

export default defineComponent({
  name: 'SearchPreFilters',
  directives: {
    portalToBody,
  },
  components: {
    UCModal,
    SearchPreFiltersContent,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object as PropType<ISearchPreFiltersConfig>,
      required: true,
    },
    value: {
      type: Object as PropType<ISearchPreFiltersValue>,
      default: () => ({}),
    },
    facetOptions: {
      type: Object as PropType<IFacetOptionsBySection>,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, { emit }) {
    const { isMobile } = useResponsive();

    const onClose = () => emit('close');
    const onClear = () => emit('clear');
    const onChange = (value: ISearchPreFiltersValue, activeTabIndex: number) =>
      emit('change', value, activeTabIndex);
    const onSearch = (value: ISearchPreFiltersValue, activeTabIndex: number) =>
      emit('search', value, activeTabIndex);

    return { isMobile, onClose, onClear, onChange, onSearch };
  },
});
